import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Product from './pages/Product';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Account from './pages/Account';
import ServiceDetail from './pages/ServiceDetail';
import ProductDetail from './pages/ProductDetail';
import Policy from './pages/Policy';
import { useEffect } from 'react';
import { useSettings } from './context/SettingsContext';
// import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import nProgress from 'nprogress';
import ForgotPassword from './pages/ForgotPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndCondition from './pages/TermsAndCondition';
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer } from 'react-toastify';
import Thankyou from './pages/Thankyou';
import Payment from './pages/Payment';
// import PaymentAssistForm from './pages/PaymentAssistForm';
import PaymentAssistCallback from './pages/PaymentAssistCallback';
// import TestDVLA from './pages/DVLA';

function App() {

  const location = useLocation();
  const { settings } = useSettings();

  useEffect(() => {
    nProgress.start();
    const timer = setTimeout(() => {
      nProgress.done();
    }, 700);
    const linkElement = document.querySelector('link[rel="icon"]');
    if (linkElement) {
      linkElement.href = `${settings?.favicon}`;
    }

    return () => clearTimeout(timer);
  }, [location, settings]);

  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/account" element={<Account />} />
        <Route path="/service/:id" element={<ServiceDetail />} />
        <Route path="/product/:ProductCode" element={<ProductDetail />} />
        <Route path="/policies" element={<Policy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-assist/callback" element={<PaymentAssistCallback />} />
        {/* <Route path="/dvla-details" element={<TestDVLA />} /> */}
      </Routes>
      <ToastContainer position="top-center" autoClose={2000} />
      <Footer />
    </>
  );
}

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
